// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"d2725d32","144":"5142f8bf","285":"15cf43d7","615":"635c9109","701":"5220c47a","738":"b3c54d08","751":"7336153c","818":"634adec7","823":"e7b0d017","860":"635e82bd","900":"f4c3075b"}[chunkId] + ".chunk.js";
};